// Placement-group scaffold for the "Preview Ads" modal — groups ad cards by
// placement name (name + badge + scroll row). This module only decides which
// groups exist; per-card rendering is in the placement-specific variation builders.

export const PlacementPlatform = {
  META: 'meta',
  GOOGLE: 'google',
}

const META_SINGLE_IMAGE_PLACEMENTS = [
  { key: 'fb-feed-desktop', name: 'Facebook Feed Desktop', platform: PlacementPlatform.META },
  { key: 'fb-feed-mobile', name: 'Facebook Feed Mobile', platform: PlacementPlatform.META },
  { key: 'ig-feed', name: 'Instagram Feed', platform: PlacementPlatform.META },
  { key: 'ig-reels', name: 'Instagram Reels', platform: PlacementPlatform.META },
]

const META_CAROUSEL_PLACEMENTS = [
  {
    key: 'fb-feed-desktop-carousel',
    name: 'Facebook Feed Desktop — Carousel',
    platform: PlacementPlatform.META,
  },
  {
    key: 'fb-feed-mobile-carousel',
    name: 'Facebook Feed Mobile — Carousel',
    platform: PlacementPlatform.META,
  },
  { key: 'ig-feed-carousel', name: 'Instagram Feed — Carousel', platform: PlacementPlatform.META },
  {
    key: 'ig-reels-carousel',
    name: 'Instagram Reels — Carousel',
    platform: PlacementPlatform.META,
  },
]

export const GOOGLE_DISPLAY_PLACEMENTS = [
  {
    key: 'google-display-9x16',
    name: 'Google Display Ads — 9:16',
    platform: PlacementPlatform.GOOGLE,
  },
  {
    key: 'google-display-1x1',
    name: 'Google Display Ads — 1:1',
    platform: PlacementPlatform.GOOGLE,
  },
  {
    key: 'google-display-191x1',
    name: 'Google Display Ads — 1.91:1',
    platform: PlacementPlatform.GOOGLE,
  },
  {
    key: 'google-display-video',
    name: 'Google Display Ads — Video',
    platform: PlacementPlatform.GOOGLE,
  },
  {
    key: 'google-display-general',
    name: 'Google Display Ads — General',
    platform: PlacementPlatform.GOOGLE,
  },
]

export const GOOGLE_DEMAND_GEN_PLACEMENTS = [
  {
    key: 'google-demand-gen-9x16',
    name: 'Google Demand Gen Ads — 9:16',
    platform: PlacementPlatform.GOOGLE,
  },
  {
    key: 'google-demand-gen-1x1',
    name: 'Google Demand Gen Ads — 1:1',
    platform: PlacementPlatform.GOOGLE,
  },
  {
    key: 'google-demand-gen-191x1',
    name: 'Google Demand Gen Ads — 1.91:1',
    platform: PlacementPlatform.GOOGLE,
  },
  {
    key: 'google-demand-gen-4x5',
    name: 'Google Demand Gen Ads — 4:5',
    platform: PlacementPlatform.GOOGLE,
  },
]

const PLACEMENTS_BY_VARIANT = {
  'meta-single': META_SINGLE_IMAGE_PLACEMENTS,
  'meta-carousel': META_CAROUSEL_PLACEMENTS,
  'google-display': GOOGLE_DISPLAY_PLACEMENTS,
  'google-demand-gen': GOOGLE_DEMAND_GEN_PLACEMENTS,
}

export function getPlacementGroupsForCreative(variant) {
  return PLACEMENTS_BY_VARIANT[variant] ?? META_SINGLE_IMAGE_PLACEMENTS
}

// Returns the union of all active platform's placement groups for multi-platform filtering.
export function getPlacementGroupsForVariants(variants) {
  const variantList = Array.isArray(variants) ? variants : [variants]
  return variantList.flatMap(getPlacementGroupsForCreative)
}
